import api from '../../domain/api';
import {
  GET_SKINCONCERNS_STATED,
  GET_SKINCONCERNS,
  GET_SKINCONCERNS_ENDED,
  ADD_SKINCONCERN_STATED,
  ADD_SKINCONCERN,
  ADD_SKINCONCERN_ENDED,
  EDIT_SKINCONCERN_STATED,
  EDIT_SKINCONCERN,
  EDIT_SKINCONCERN_ENDED,
  GET_SKINCONCERN_STATED,
  GET_SKINCONCERN,
  GET_SKINCONCERN_ENDED,
  GET_ALL_SKINCONCERNS_STATED,
  GET_ALL_SKINCONCERNS,
  GET_ALL_SKINCONCERNS_ENDED,
} from '../types/skinconcern_type';
import * as qs from 'qs';
import { handleError } from '../../shared/handleError';
import { setAlert } from './alert';

export const addSkinconcern = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_SKINCONCERN_STATED,
    });
    const { data } = await api.post(`/skinconcerns`, formData);
    dispatch({
      type: ADD_SKINCONCERN,
      payload: data,
    });
    dispatch({
      type: ADD_SKINCONCERN_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_SKINCONCERN_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getSkinconcerns =
  ({ pageNumber = '' }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_SKINCONCERNS_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace('?', ''));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/skinconcerns?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_SKINCONCERNS,
        payload: data,
      });
      dispatch({
        type: GET_SKINCONCERNS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_SKINCONCERNS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getSkinconcern = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_SKINCONCERN_STATED,
    });
    const { data } = await api.get(`/skinconcerns/${id}`);

    dispatch({
      type: GET_SKINCONCERN,
      payload: data,
    });
    dispatch({
      type: GET_SKINCONCERN_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_SKINCONCERN_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editSkinconcern = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_SKINCONCERN_STATED,
    });

    console.log('form data --->', formData);
    const { data } = await api.put(`/skinconcerns/${id}`, formData);
    dispatch({
      type: EDIT_SKINCONCERN,
      payload: data,
    });
    dispatch({
      type: EDIT_SKINCONCERN_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_SKINCONCERN_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteSkinconcern = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/skinconcerns/${id}`);
    dispatch(setAlert('Skinconcern Deleted Successfully', 'success'));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllSkinconcerns =
  ({ term, value }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_SKINCONCERNS_STATED,
      });
      const { data } = await api.get(
        `/skinconcerns/all?term=${term}&value=${value}`
      );

      dispatch({
        type: GET_ALL_SKINCONCERNS,
        payload: data,
      });
      dispatch({
        type: GET_ALL_SKINCONCERNS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_SKINCONCERNS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };

export const handleErrorLocal = () => async (dispatch) => {};
